import Routing from "imports-loader?window=>this!router.js";
import "imports-loader!fos_js_routes.js";

// Temporary fix to set host
for (let item in Routing.Routing) {
    if (Routing.Routing[item].host) {
        Routing.Routing[item].host = document.location.host;
        Routing.Routing[item].scheme = "https";
    }
}

module.exports = Routing.Routing;
